const initialState = () => ({
  exhibitions: [],
  pagination: {
    page: 1,
    rowsPerPage: 15,
    rowsNumber: 0
  },
  loading: false,
  exhibition: null,
  types: [],
  places: [],
  promoters: [],
  // Estado de los filtros del listado
  filters: {
    status: 'active',
    locations: [],
    order_by: 'created_at',
    direction: 'desc'
  },
  hasActiveFilters: false
})

export default initialState
